/* src/app/payroll/employee-payroll-item/employee-payroll-item-filter/employee-payroll-item-filter.component.scss */
:host ::ng-deep .p-multiselect {
  width: 100%;
}
:host ::ng-deep .p-multiselect-label {
  min-width: 10em;
}
/*# sourceMappingURL=employee-payroll-item-filter.component.css.map */
